import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import BaseError from '../../../utils/base-error';
import { CateringEventFormatPageState } from './catering-event-format-page-state';
import { CateringEventFormatPageActions } from './actions';
import {
    createCateringEventFormatFromGetCateringEventFormatBySlugApiResponse,
    createCateringEventsFromGetCateringEventsByFormatSlugApiResponse,
} from '../utils';

const initialState: CateringEventFormatPageState = {
    loaded: false,
    errors: [],
    cateringEvents: [],
};

export const cateringEventFormatSlice = createSlice({
    name: 'cateringEventFormatSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            CateringEventFormatPageActions.getCateringEventFormatBySlug.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createCateringEventFormatFromGetCateringEventFormatBySlugApiResponse(
                            response.data,
                        );

                        state.cateringEventFormat = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            CateringEventFormatPageActions.getCateringEventsByFormatSlug.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createCateringEventsFromGetCateringEventsByFormatSlugApiResponse(
                            response.data,
                        );

                        state.cateringEvents = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
